import { render, staticRenderFns } from "./118.vue?vue&type=template&id=62b01b71&scoped=true&"
var script = {}
import style0 from "./118.vue?vue&type=style&index=0&id=62b01b71&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62b01b71",
  null
  
)

export default component.exports